import {Suspense} from 'react';
import {Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {ReactBaseComponent} from '../../../../react/base/react-base.component';
import {MaterialTransaction} from '../../material-management.model';
import {
  MaterialTransactionHistoryMachines,
} from '../../../../react/material/transaction/history/machines/material-transaction-history-machines';
import {ErrorBoundary} from '../../../../react/errorhandling/ErrorBoundary';
import {EvLoadingSpinner} from '../../../../react/components/loading/ev-loading-spinner';

const containerElementName = 'reactTransactionHistoryMachineList';

@Component({
  selector: 'transaction-machine-list',
  template: `<div class="inline-block w-96" #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TransactionMachineListReactComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() transaction: MaterialTransaction;

  constructor() {
    super();
  }

  protected renderComponent() {
    return <ErrorBoundary>
      <Suspense fallback={<EvLoadingSpinner/>}>
        <MaterialTransactionHistoryMachines transaction={this.transaction}/>
      </Suspense>
    </ErrorBoundary>;
  }
}
